module.exports = __webpack_public_path__ + "img/restaurant.9079325d.png";